export const START_SCREEN_IMAGE_URL = `${process.env.NEXT_PUBLIC_STATIC_URL}/images/partnerStartScreen`;
export const START_SCREEN_ARRAY_LENGTH = 3;